import { useState } from 'react';
import { Link } from 'react-router-dom';
import * as api from '../services/api';
import './AuthPage.css';

export function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setMessage('');

        const response = await api.forgotPassword(email);

        if (response.success) {
            setMessage(response.message || 'If an account exists, a reset email has been sent.');
        } else {
            setError(response.error || 'Failed to send reset email');
        }
        setLoading(false);
    };

    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-header">
                    <h1>Forgot Password 🔐</h1>
                    <p>Enter your email to reset your password.</p>
                </div>

                {message ? (
                    <div className="success-message">
                        <p>{message}</p>
                        <Link to="/login" className="btn btn-secondary full-width" style={{ marginTop: '1rem' }}>
                            Back to Login
                        </Link>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        {error && <div className="error-message">{error}</div>}

                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>

                        <button type="submit" className="btn btn-primary full-width" disabled={loading}>
                            {loading ? 'Sending...' : 'Send Reset Link'}
                        </button>

                        <div className="auth-footer">
                            <Link to="/login">Back to Login</Link>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
